import React from 'react';
import { useSelector} from "react-redux";
import { getConfig } from "./../../store/settings/selectors";

import MdmStudiArchitettura from "./../../tenants/MDM/StudiArchitettura";

import Analytics from "../Analytics/Analytics";

const MainComponent = ({ tenant }) => {
  switch (tenant) {
    case "MDM":
      return <MdmStudiArchitettura />;
    default:
      // Solo MDM ha questa pagina, altri tenant non la visualizzano
      return null;
  }
}

export default function StudiArchitettura(){
  const config = useSelector(getConfig);
  return (
    <>
      <Analytics name="studi-architettura" />
      <MainComponent tenant={config.tenant} />
    </>
  )
}
